import React from 'react';
import SectionTitle from '../SectionTitle/SectionTitle';
import './ProcessSection.css';
import Shape from '../../images/work/shape.svg'

const ProcessSection = (props) => {
    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-9 col-12">
                        <SectionTitle title={'Your Treatment Journey at Amped Therapeutics'} subtitle={'Your Concierge Regenerative Medicine Journey'}/>
                    </div>
                </div>
                <div className="work_wrapper">
                    <div className="row">
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="icon-circle">
                                    <i className="fas fa-stethoscope"></i>
                                </div>
                                <div className="text">
                                    <h3>1) Comprehensive Evaluation</h3>
                                    <p>Begin with Dr. Pereira's comprehensive consultation - available at premium Florida locations convenient to you. We evaluate your condition and determine your optimal regenerative medicine protocol.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="icon-circle">
                                    <i className="fas fa-clipboard-list"></i>
                                </div>
                                <div className="text">
                                    <h3>2) Personalized Protocol Design</h3>
                                    <p>Receive Dr. Pereira's personalized treatment plan utilizing Florida's advanced regulatory framework. We design protocols combining 25+ years of expertise with cutting-edge regenerative therapies.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="icon-circle">
                                    <i className="fas fa-dna"></i>
                                </div>
                                <div className="text">
                                    <h3>3) Advanced Regenerative Treatment</h3>
                                    <p>Undergo your cutting-edge stem cell procedure at our partner state-of-the-art facilities across Florida. Dr. Pereira's mobile team delivers Wharton's jelly MSC therapy and advanced regenerative treatments with hospital-grade precision.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                            <div className="work_card">
                                <div className="icon-circle">
                                    <i className="fas fa-heart-circle-check"></i>
                                </div>
                                <div className="text">
                                    <h3>4) Concierge Recovery Support</h3>
                                    <p>Experience comprehensive healing with our structured monitoring and aftercare program. Our concierge model ensures continuous support throughout your regenerative journey, optimizing outcomes and tracking your transformation.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape">
                        <img src={Shape} alt="" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ProcessSection;